import { useNavigate } from "react-router-dom";


const Menu = () => {

    const navigate = useNavigate();
    const flowExpertAdminLink = process.env.REACT_APP_FLOW_EXPERT_ADMIN_LINK
    const sharedDiscLink = process.env.REACT_APP_DISC_LINK

    return (
        <div className="menu-new-container">
            <div className='menu-new-card'>
                <h2 className='menu-new-title'>Menu</h2>
                <button className='menu-new-button' onClick={() => navigate('/choice')}>
                    Choice
                </button>
                <button className='menu-new-button' onClick={() => navigate('/manage-database')}>
                    Manage Database
                </button>
                <button className='menu-new-button' onClick={() => navigate('/manage-calculations')}>
                    Manage Calculations
                </button>
                <button className='menu-new-button' onClick={() => navigate('/data-transmission')}>
                    Data Transmission
                </button>
                <button className='menu-new-button' onClick={() => window.location.href=sharedDiscLink}>
                    Shared Disc
                </button>
                <button className='menu-new-button' onClick={() => window.location.href=flowExpertAdminLink}>
                    Administrator Page
                </button>
                <button className='menu-new-button' onClick={() => navigate('/logout')}>
                    Logout
                </button>
            </div> 
        </div>
    );
};

export default Menu;
